.container {
	position: relative;
	height: 100%;
	overflow: hidden;
	.fullscreenWrapper {
		height: 100%;
		canvas {
			max-width: 100%;
		}
	}

	@include screen-md {
		overflow: hidden;
		height: 50dvh;
		.closeFullScreenBtn {
			position: fixed;
			top: 1rem;
			right: 1rem;
			z-index: 1;
		}
	}
}
